<template>
  <td class="rowindex state-disabled" width="5%">
    <b>
      <slot name="after" />
      {{ index + 1 }}.
      <slot name="before" />
    </b>
  </td>
</template>

<script>
export default {
  name: 'w-lp-cell',
  props: {
    index: {
      type: Number,
      required: true
    }
  }
};
</script>
